/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import React from 'react';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import theme from '../../../../../Shared/Themes/theme';
import { Icons } from '../../../../../Shared/Constants/Icons';
import { NoteText } from '../AllJobs.Style';
import { Loader } from '../../../../Jobs/Components/JobView/JobsView.styles';

interface IAvailableTasksListProps {
  tasks: any[];
  isLoading: boolean;
  handleAddSubTaskClick: (task: any) => void;
}

const AvailableTasksList: React.FC<IAvailableTasksListProps> = ({ tasks, isLoading, handleAddSubTaskClick }) => {
  const { t } = useTranslation(['taskManagement', 'altTexts']);

  const renderTask = (task: any) => (
    <Box
      key={task.taskId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0.5rem 1rem',
        border: '2px solid #e5e7eb',
        borderRadius: '1rem',
        width: '45%',
      }}>
      <Typography sx={{ color: 'grey.900' }}>{task.taskName}</Typography>
      <IconButton
        size="large"
        sx={{ '&:hover': { background: theme.palette.primary.main } }}
        onClick={() => handleAddSubTaskClick(task)}>
        <img src={Icons.AddIcon} width={24} height={24} alt={t('altTexts:add')} />
      </IconButton>
    </Box>
  );

  if (isLoading) {
    return (
      <Loader>
        <CircularProgress style={{ marginTop: '2rem', color: '#006B6B' }} />
      </Loader>
    );
  }

  if (isEmpty(tasks)) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <NoteText>{t('taskManagement:NoTasksFound')}</NoteText>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        mb: 2,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}>
      {tasks?.map(renderTask)}
    </Box>
  );
};

export default AvailableTasksList;
